import { RUN_RELATED_TYPES } from '@/entities/asset-search';
import type { OpenMetadataSource, SearchResult } from '@/entities/search';

import { useAssetSearchPreview } from './useAssetSearchPreview';
import { useOpenMetadataPreview } from './useOpenMetadataPreview';

type UseAssetPreviewProps = {
  selectedResult: SearchResult | null;
  sourceData?: OpenMetadataSource;
};

/**
 * useAssetPreview
 *
 * Orchestrates the preview logic by delegating to specialized hooks based on asset type.
 */
export const useAssetPreview = ({ selectedResult, sourceData }: UseAssetPreviewProps) => {
  const rawAssetItem = selectedResult?._source?.rawAssetItem;
  const isAssetSearch = rawAssetItem && RUN_RELATED_TYPES.some((t) => t === selectedResult.type);

  const assetSearchPreview = useAssetSearchPreview({ selectedResult });
  const omPreview = useOpenMetadataPreview({ selectedResult, sourceData });

  if (isAssetSearch) {
    return {
      infoRows: assetSearchPreview.infoRows,
      sections: assetSearchPreview.sections,
      description: assetSearchPreview.description,
      isLoading: assetSearchPreview.isLoading,
      isError: assetSearchPreview.isError,
      refetch: assetSearchPreview.refetch,
    };
  }

  return {
    infoRows: omPreview.infoRows,
    sections: omPreview.sections,
    description: omPreview.description,
    isLoading: omPreview.isLoading,
    isError: omPreview.isError,
    refetch: omPreview.refetch,
  };
};
